import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'icon-close-circle',
  props: {
  width: {
    type: String,
    default: 'w-3.5',
  },
  height: {
    type: String,
    default: 'h-3.5',
  },
  color: {
    type: String,
    default: 'text-current',
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})